import StandardMobileCallToActionGameModule, {
    StandardMobileCallToActionGameModuleProps,
} from '../../game/mobileCallToAction/StandardMobileCallToActionGameModule';

export function StandardMobileCallToActionSellergroupModule(props: StandardMobileCallToActionSellergroupModuleProps) {
    return <StandardMobileCallToActionGameModule {...props} />;
}

export type StandardMobileCallToActionSellergroupModuleProps = StandardMobileCallToActionGameModuleProps;

export default StandardMobileCallToActionSellergroupModule;
